// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"insightSideBar-module--side-bar--3qs1w"};